export default "__VITE_ASSET__24711bdc__"